import { ACTION_STATES, ComplexAction, createHandler, createReducer, DefaultAction } from "core/actions";
import { assertArray } from "core/validation";
import { deleteFromState } from "../../common";

const logicError = {
    invalidFilmRelease: null,
    advExist: false,
    advToAdd: [],
};
const initState = {
    advertisers: [],
    filteredAdvertisers: [],
    filmReleases: [],
    advertisementTypes: [],
    primaryRecipient: null,
    ccRecipients: [],
    reportDate: null,
    additionStatus: ACTION_STATES.NO_REQUEST,
    loadingStatus: ACTION_STATES.NO_REQUEST,
    logicError: logicError,
    advToReport: [],
    filmSelected: [],
    adtType: null,
    showComments: true,
};

export class ON_ADD_ADV_TO_LOG_REPORT extends ComplexAction {
    successRdx(state, { payload }) {
        return Object.assign({}, state, {
            ...payload,
            additionStatus: ACTION_STATES.SUCCESS,
        });
    }
    failedRdx(state, action) {
        const { payload } = action;
        if (payload.logicError) {
            return Object.assign({}, state, {
                additionStatus: ACTION_STATES.FAILED,
                logicError: payload.logicError,
            });
        } else {
            super.failedRdx(state, payload);
        }
    }
}

export class ON_LOAD_LOG_REPORT_VIEW extends ComplexAction {}
export class ON_LOG_FILTER_BY_TYPE extends DefaultAction {
    callRdx(state, { payload }) {
        if (payload) {
            const advToReport = state.advertisers.filter((a) => a.advertisementType.id === payload.id);
            return Object.assign({}, state, {
                advToReport,
                advType: payload,
            });
        } else {
            return Object.assign({}, state, {
                advToReport: state.advertisers,
                advType: payload,
            });
        }
    }
}

export class ON_REMOVE_FROM_LOG_REPORT extends DefaultAction {
    callRdx(state, { payload }) {
        const toUpdate = deleteFromState(payload, state);
        const exisingAdx = toUpdate.advertisers.filter((adv) => adv.filmRelease.id === payload.filmRelease.id);
        let filmReleases = state.filmReleases;
        if (!assertArray(exisingAdx)) {
            filmReleases = state.filmReleases.filter((film) => film.id !== payload.filmRelease.id);
        }
        return Object.assign({}, state, {
            ...toUpdate,
            filmReleases,
        });
    }
}

export class ON_CLEAR_LOG_REPORT extends DefaultAction {
    callRdx() {
        return { ...initState, advertisers: [], advToReport: [] };
    }
}
export class ON_ADD_GLOBAL_LOG_REPORT extends ComplexAction {}
export class ON_PREVIEW_LOG_REPORT extends DefaultAction {}
export class ON_CLEAR_LOG_REPORT_ERROR extends DefaultAction {
    callRdx(state) {
        return Object.assign({}, state, {
            logicError,
        });
    }
}

export class ON_CLEAR_WITH_NEW_FILM_RELEASE_LOG extends DefaultAction {}

export class SET_FILTERED_ADVERTISERS extends DefaultAction {
    callRdx(state, { payload }) {
        const advToReport = state.advertisers.filter(
            (adv) => payload.findIndex((fRId) => fRId === adv.filmRelease.id) !== -1
        );
        return {
            ...state,
            advToReport,
        };
    }
}
export class CLEAR_FILTERED_ADVERTISERS extends DefaultAction {
    callRdx(state) {
        return {
            ...state,
            advToReport: state.advertisers,
        };
    }
}

export class ON_REMOVE_FILM_FROM_LOG_LIST extends DefaultAction {
    callRdx(state, { payload }) {
        const id = payload;
        const filmReleases = state.filmReleases.filter((f) => f.id !== id);
        const advertisers = state.advertisers.filter((ad) => ad.filmRelease.id !== id);
        const advToReport = state.advToReport.filter((ad) => ad.filmRelease.id !== id);
        return Object.assign({}, state, {
            filmReleases,
            advToReport,
            advertisers,
            advertisersCount: advertisers.length,
        });
    }
}

export class ON_GENERATE_LOG_PREVIEW_URL extends DefaultAction {}
export class ON_SET_SHOW_COMMENTS extends DefaultAction {}

export const actions = {
    ON_ADD_ADV_TO_LOG_REPORT: new ON_ADD_ADV_TO_LOG_REPORT({ loadingAtr: "additionStatus" }),
    ON_LOAD_LOG_REPORT_VIEW: new ON_LOAD_LOG_REPORT_VIEW({ loadingAtr: "loadingStatus" }),
    ON_LOG_FILTER_BY_TYPE: new ON_LOG_FILTER_BY_TYPE(),
    ON_REMOVE_FROM_LOG_REPORT: new ON_REMOVE_FROM_LOG_REPORT(),
    ON_CLEAR_LOG_REPORT: new ON_CLEAR_LOG_REPORT(),
    ON_PREVIEW_LOG_REPORT: new ON_PREVIEW_LOG_REPORT(),
    ON_CLEAR_LOG_REPORT_ERROR: new ON_CLEAR_LOG_REPORT_ERROR(),
    ON_CLEAR_WITH_NEW_FILM_RELEASE_LOG: new ON_CLEAR_WITH_NEW_FILM_RELEASE_LOG(),
    ON_ADD_GLOBAL_LOG_REPORT: new ON_ADD_GLOBAL_LOG_REPORT({ loadingAtr: "addingGlobalReportStatus" }),
    SET_FILTERED_ADVERTISERS: new SET_FILTERED_ADVERTISERS(),
    CLEAR_FILTERED_ADVERTISERS: new CLEAR_FILTERED_ADVERTISERS(),
    ON_REMOVE_FILM_FROM_LOG_LIST: new ON_REMOVE_FILM_FROM_LOG_LIST(),
    ON_SET_SHOW_COMMENTS: new ON_SET_SHOW_COMMENTS("showComments"),
    ON_GENERATE_LOG_PREVIEW_URL: new ON_GENERATE_LOG_PREVIEW_URL(),
};

const handlers = createHandler(actions);

export default createReducer(initState, handlers);

export const advertisersSelector = (state) => state.reportLog.advertisers;
export const advertisersIdsSelector = (state) => state.reportLog.advertisers.map((adv) => adv.id);
export const filmReleasesLogReportSelector = (state) => state.reportLog.filmReleases;
export const advInLogicErrorSelector = (state) => state.reportLog.logicError.advToAdd;
export const filmReleaseInLogicErrorSelector = (state) => state.reportLog.logicError.invalidFilmRelease;
export const showCommentSelector = (state) => state.reportLog.showComments;
export const advToLogReportSelector = (state) => {
    return assertArray(state.reportLog.advToReport) ? state.reportLog.advToReport : [];
};
